/**
 * @component
 * @visibleName formatNumber
 */
export default function formatNumber(numberValue: number, { locale }: { locale: string }) {
  const resolvedLocale = locale.substring(0, 2);
  const thousandDelimiter = (resolvedLocale === 'fr') ? ' ' : ',';
  const decimalDelimiter = (resolvedLocale === 'fr') ? ',' : '.';
  const [integer, decimals] = String(numberValue).split('.');

  const formattedInteger = String(integer).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousandDelimiter}`);

  return [
    formattedInteger,
    decimals,
  ].filter((part) => part).join(decimalDelimiter);
}
